import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconsModule } from '@progress/kendo-angular-icons';
import { StaffSearchComponent } from './staff-search.component';
import { FormFieldModule, MaskedTextBoxModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { GridModule } from '@progress/kendo-angular-grid';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';

@NgModule({
  declarations: [StaffSearchComponent],
  imports: [
    CommonModule,
    FontAwesomeModule,
    IconsModule,
    TextBoxModule,
    LabelModule,
    GridModule,
    ButtonsModule,
    FormFieldModule,
    ReactiveFormsModule,
    IndicatorsModule,
    DropDownsModule,
    FormsModule,
    MaskedTextBoxModule
  ],
  exports: [StaffSearchComponent],
})
export class StaffSearchModule {}
